import { render, staticRenderFns } from "./CreateSetMeal.vue?vue&type=template&id=13fd5cf9&scoped=true&"
import script from "./CreateSetMeal.vue?vue&type=script&lang=js&"
export * from "./CreateSetMeal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSetMeal.vue?vue&type=style&index=0&id=13fd5cf9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd5cf9",
  null
  
)

export default component.exports